import {useMutation, useQueryClient} from "@tanstack/react-query";
import {message} from "antd";
import {AxiosError} from "axios";
import {WithdrawalRequest, WithdrawalResponse} from "../domain/types";
import {createWithdrawalRepository} from "../data/repositories";

/**
 * Hook for initiating a withdrawal.
 * Returns strongly-typed WithdrawalResponse with Stripe fields.
 */
export const useInitiateWithdrawal = () => {
  const queryClient = useQueryClient();
  const repository = createWithdrawalRepository();

  return useMutation<
    WithdrawalResponse,
    AxiosError<{message: string}>,
    WithdrawalRequest
  >({
    mutationFn: (request) => repository.initiateWithdrawal(request),
    onError: (error) => {
      message.error(error.response?.data?.message || error.message);
    },
    onSettled: () => {
      Promise.all([
        queryClient.invalidateQueries({queryKey: ["account_balance"]}),
        queryClient.invalidateQueries({queryKey: ["pending_payout"]}),
        queryClient.invalidateQueries({queryKey: ["payout_history"]}),
      ]);
    },
  });
};
